import { useTranslation } from "react-i18next";
import { Arrow } from "../icons/arrow"
import { useEffect, useState } from "react";
import { Slider } from "@mui/material";
import { formatText } from "../utils/functions";

const clamp = (val, min, max) => Math.min(Math.max(val, min), max);

export const Filters = ({ currLvl, activeFilters, setActiveFilters, areaFilters, setAreaFilters, currUnits, hidden, setCurrLvl, area }) => {
    const { i18n, t } = useTranslation();
    // const [area, setArea] = useState({ min: 0, max: 100 });



    const setNextPrev = (state) => {
        let num = currLvl;
        if (num === 9 && state === "next") {
            num = 2;
        } else if (num === 2 && state === "prev") {
            num = 9;
        } else {
            if (state === "next") {
                num++;
            } else {
                num--
            }
        }
        setCurrLvl(num)
    }

    return (
        <div className={`transition-all hidden lg:flex flex-col absolute bottom-0 right-0 z-[10] py-2 px-4 lg:px-8 bg-[var(--blue)] border-t border-t-[var(--gold)] border-l border-l-[var(--gold)] justify-center gap-3 sm:rounded-tl-[60px] ${hidden ? "translate-y-[100%]" : "translate-y-[0]"}`}>
            {/* Floor */}
            <div className="flex gap-3 items-center justify-center">
                <div className="cursor-pointer text-[var(--gold)] hover:text-[var(--white)]" onClick={() => setNextPrev("prev")}><Arrow color="inherit" inversed /></div>
                <h3 className="font-[Caslon] capitalize text-[16px] lg:text-[21px] text-[var(--gold)] select-none">{`${t("floor")} ${currLvl.toString().padStart(2, '0')}`}</h3>
                <div className="cursor-pointer text-[var(--gold)] hover:text-[var(--white)]" onClick={() => setNextPrev("next")}><Arrow color="inherit" /></div>
            </div>

            <div className="w-full h-[1px] bg-[var(--gold)] mb-1 -mt-1"></div>
            {/* Filters */}
            <div className="flex items-center">
                <h3 className="lg:w-[110px] w-[80px] font-[Caslon] text-[12px] lg:text-[16px] text-[var(--gold)]">{t("unitType")}</h3>
                <div className="flex text gap-3">
                    <FilterButton type={"1.5"} active={activeFilters} setActiveFilters={setActiveFilters} />
                    <FilterButton type={"3.5"} active={activeFilters} setActiveFilters={setActiveFilters} />
                    <FilterButton type={"4.5"} active={activeFilters} setActiveFilters={setActiveFilters} />
                    <FilterButton type={"5.5"} active={activeFilters} setActiveFilters={setActiveFilters} />
                </div>
            </div>
            <div className="flex items-center mb-2">
                <h3 className="lg:w-[110px] w-[80px] font-[Caslon] text-[12px] lg:text-[16px] text-[var(--gold)]">{t("area")}</h3>
                <div className="flex-1 flex">
                    <Slider
                        className="rangeSlider"
                        value={areaFilters}
                        step={100 / (area.max - area.min)}
                        onChange={(e, v) => setAreaFilters(v)}
                        valueLabelDisplay="auto"
                        valueLabelFormat={(v) => formatText(v, area.min, area.max)}
                    />
                </div>
                <p className="lg:w-[100px] w-[80px] text-right font-[Caslon] text-[var(--gold)] text-[11px] lg:text-[14px]">{`${formatText(areaFilters[0], area.min, area.max)} - ${formatText(areaFilters[1], area.min, area.max)} ${t("ft")}`}</p>
            </div>
        </div>
    )
}

const FilterButton = ({ type, active, setActiveFilters }) => {
    const unit = type == "1.5" ? "Studio" : type.replace(".5", "½");
    const isActive = active?.[type];
    return (
        <div
            onClick={() => setActiveFilters(el => ({ ...el, [type]: !el[type] }))}
            className={`cursor-pointer transition-colors border font-[Caslon] text-[var(gold)] border-[var(--gold)] w-[60px] lg:w-[80px] text-center py-[1px] lg:py-[3px] text-[11px] lg:text-[13px] ${isActive ? "bg-[var(--gold)] text-white hover:bg-[var(--goldLite)]" : "text-[var(--gold)] hover:text-[var(--goldLite)] hover:border-[var(--goldLite)]"}`}
        >
            {unit}
        </div>
    )
}